import PropTypes from "prop-types";

const adminActionType = PropTypes.shape({
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  trackAction: PropTypes.string.isRequired,
});

export default adminActionType;
